import React from 'react';
import Iconify from '../../@core/theme/Iconify';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const menuSideBar = [
  {
    title: 'Dashboard',
    path: '/app/dashboard',
    icon: getIcon('eva:pie-chart-2-fill')
  },
  {
    title: 'Assinaturas',
    path: '/app/signature',
    icon: getIcon('eva:edit-outline')
  },
  {
    title: 'Vendas',
    icon: getIcon('eva:layers-outline'),
    children: [
      {
        title: 'Propostas',
        path: '/app/clients'
      },
      {
        title: 'Cotações',
        path: '/app/simulations'
      },
      {
        title: 'Cotação',
        path: '/app/quotation'
      }
    ]
  },
  {
    title: 'Pipeline',
    icon: getIcon('eva:grid-outline'),
    children: [
      {
        title: 'Kanban',
        path: '/app/pipeline/kanban'
      },
      {
        title: 'Funil de vendas',
        path: '/app/pipeline/funnel'
      }
    ]
  },
  {
    title: 'Leads',
    icon: getIcon('eva:people-outline'),
    children: [
      {
        title: 'Kanban de leads',
        path: '/app/leads/kanban'
      }
    ]
  },
  {
    title: 'Cadastros',
    icon: getIcon('eva:archive-fill'),
    children: [
      {
        title: 'Controle de acesso',
        children: [
          {
            title: 'Usuários',
            path: '/app/users'
          },
          {
            title: 'Permissões padrões',
            path: '/app/permissions'
          }
        ]
      },
      {
        title: 'Operadoras',
        path: '/app/operators'
      },
      {
        title: 'Corretoras',
        path: '/app/brokers'
      },
      {
        title: 'Associações',
        path: '/app/associations'
      },
      {
        title: 'Avisos',
        path: '/app/warnings'
      },
      {
        title: 'Formulários',
        path: '/app/forms'
      },
      {
        title: 'Declaração de saúde',
        path: '/app/declarationHealth'
      },
      {
        title: 'Cadastro de vigências',
        path: '/app/terms'
      },
      {
        title: 'Cadastro de restrições',
        path: '/app/restrictions'
      }
    ]
  },
  {
    title: 'Financeiro',
    icon: <LocalAtmIcon />,
    children: [
      {
        title: 'Cadastros',
        children: [
          {
            title: 'Produtos',
            path: '/app/products'
          },
          {
            title: 'Tabelas',
            path: '/app/tables'
          },
          {
            title: 'Reajustes',
            path: '/app/readjustments'
          },
          {
            title: 'Carências',
            path: '/app/shortages'
          }
        ]
      },
      {
        title: 'Comissões',
        path: '/app/comissions'
      }
    ]
  },
  {
    title: 'Relatórios',
    icon: getIcon('eva:activity-outline'),
    children: [
      {
        title: 'Financeiro',
        children: [
          {
            title: 'Relatório de vendas',
            path: '/app/reports/repSales'
          },
          {
            title: 'Relatório de simulações',
            path: '/app/reports/repSimulations'
          }
        ]
      }
    ]
  },
  {
    title: 'Configurações',
    icon: getIcon('eva:settings-2-fill'),
    children: [
      {
        title: 'Configurações de email',
        path: '/app/email'
      },
      {
        title: 'Configurações do sistema',
        path: '/app/config'
      }
    ]
  },
  {
    title: 'AI Chat',
    path: '/app/iaChat',
    icon: getIcon('eva:message-square-outline')
  }
];

const navConfig = (permissions) => {
  let menu = [];

  menuSideBar.map((item) => {
    permissions.map((permission) => {
      if (permission.name === item.title) {
        menu.push(item);
      }
      if (item.children) {
        item.children.map((child) => {
          if (permission.name === child.title) {
            if (!menu.filter((e) => e.title === item.title).length > 0) {
              menu.push({
                title: item.title,
                icon: item.icon,
                children: [child]
              });
            } else {
              menu.map((m) => {
                if (m.title === item.title) {
                  m.children.push(child);
                }
              });
            }
          } else {
            if (child.children) {
              child.children.map((subChild) => {
                if (permission.name === subChild.title) {
                  if (!menu.filter((e) => e.title === item.title).length > 0) {
                    child.children.map((subChild2) => {
                      if (!menu.filter((e) => e.title === subChild2.title).length > 0) {
                        if (subChild2.title === subChild.title) {
                          menu.push({
                            title: item.title,
                            icon: item.icon,
                            children: [
                              {
                                title: child.title,
                                children: [subChild2]
                              }
                            ]
                          });
                        } else {
                          menu.map((m) => {
                            if (m.title === item.title) {
                              m.children.map((c) => {
                                permissions.map((p) => {
                                  if (p.name === subChild2.title) {
                                    c.children.push(subChild2);
                                  }
                                });
                              });
                            }
                          });
                        }
                      } else {
                        menu.map((m) => {
                          if (m.title === item.title) {
                            m.children.push(subChild2);
                          }
                        });
                      }
                    });
                  }
                }
              });
            }
          }
        });
      }
    });
  });
  return [...new Set(menu)];
};

export default navConfig;
